import { Deserializable, JsonObject, Serializable } from '@ktypes/models';

export class AnswerValue implements Deserializable<any, AnswerValue>, Serializable<JsonObject> {
  constructor(public optionId?: string, public value?: any) {}

  deserialize(input: any): AnswerValue {
    if (input == null) {
      return null;
    }
    this.optionId = input.optionId;
    this.value = input.value;
    return this;
  }

  serialize(): JsonObject {
    const json: JsonObject = {};
    json['optionId'] = this.optionId;
    json['value'] = this.value;
    return json;
  }
}
